// extracted by mini-css-extract-plugin
module.exports = {"PhotoTitleEditForm__submitBtn":"jn_a bhs_rm","PhotoTitleEditForm__cancelBtn":"jn_b bhs_rq bhs_rp"};